export const kvControlHeight = () => {
  const kvElement = document.querySelector('.top-kv');
  const spKvContents = document.querySelector('.top-kv__sp-content-wrap');

  if (window.innerWidth < 1024) {
    kvElement.style.height = spKvContents.clientHeight + 'px';
  } else {
    kvElement.style.height = '';
  }
};
